import FreemiumEventCreateWaldoficationStep from './FreemiumEventCreateWaldoficationStep';

export default FreemiumEventCreateWaldoficationStep;
